export default {
  getUserRoles: state => state.activeUser.roles,
  getUser: state => state.activeUser,
  getUserTokens: state => state.activeUserTokens,
  getUserTeam: state => state.userTeam,
  isTeamLoaded: state => state.teamLoaded,
  getShowInitTeamPopup: state => state.showInitTeamPopup,
  getNotifications: state => state.notifications,
  getImpersonation: state => state.impersonation,
  isImpersonating: state => Boolean(state.impersonation),
}
